import { useQuery } from '@tanstack/react-query';

const useHappyEndingsList = () => {
  return useQuery({
    queryKey: ['happyEndings'],
    queryFn: async () => {
      const response = await fetch(
        import.meta.env.VITE_PAWFRIENDS_API_ENDPOINT_GET_HAPPY_ENDINGS
      );

      if (!response.ok) {
        throw new Error('Failed to fetch happy endings');
      }

      const data = await response.json();

      // opcionalno: sortiranje po datumu descending
      data.sort((a, b) => new Date(b.date) - new Date(a.date));

      return data;
    },
    staleTime: 1000 * 60 * 30, // 30 minuta
  });
};

export default useHappyEndingsList;
